module.exports = __webpack_public_path__ + "static/fonts/Simple-Line-Icons.d228596.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SimpleLineIcons/Simple-Line-Icons.ttf?v=2.4.0
// module id = 1168
// module chunks = 5